import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-util-js/FunUtil';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';

var fn = function fn($scope, $state, lobConfig, $window, $q, $stateParams, SubmissionService, ActivityService, $modal, ModalService, $filter, UserService, $translate, InsuranceSuiteMetadata, defaultLocaleDetails, GPA_PC_ENTRY_POINT) {
    var lobMap = {
        'PersonalAutoLine': 'pa',
        'HomeownersLine_HOE': 'ho',
        'HOPLine': 'ho',
        'CPLine': 'cp',
        'BOPLine': 'bop',
        'WorkersCompLine': 'wc'
    };

    var ctrl = Object.create(BaseCtrl);

    var phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        $scope.submissionNumber = $stateParams.submissionNumber;

        var submissionRequest = SubmissionService.findJobByJobNumber($stateParams.submissionNumber).then(function (submission) {
            if (!submission.statusCode) {
                ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
                $state.go('policies.index');
            }
            $scope.submission = submission;

            $scope.accountInfo = {};
            $scope.latestPeriod = submission.policy.latestPeriod;
            $scope.policyNumber = submission.policy.policyNumber;
            $scope.submissionStatus = ctrl.getJobStatus(submission);

            if ($scope.submissionStatus.toLowerCase() === 'bound' && submission.policy.issued) {
                $scope.submissionStatusString = $filter('translate')('gateway.directives.JobSummary.Issued');
            } else {
                $scope.submissionStatusString = $scope.submissionStatus;
            }

            $scope.createTime = submission.createTime;

            mapAccountDetails(submission.policy.account);

            if ($scope.submission.statusCode === 'NotTaken') {
                $scope.isNotTaken = true;
            }
        }, function () {
            ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
            $state.go('policies.index');
        });

        var updateSummaryRequest = updateSummaryFromServer();
        $scope.renewalDetailReadyPromise = $q.all([submissionRequest, updateSummaryRequest]);
    };

    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }

        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateSubmission;

        setupAccountContactDetails(accountDetails.accountHolder);
    }

    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    ctrl.getJobStatus = function (job) {
        if (job.policy) {
            if (job.policy.issued) {
                return $filter('translate')('gateway.directives.JobSummary.Issued');
            } else if (job.status === 'Not-taken') {
                return $filter('translate')('gateway.directives.JobSummary.Not Taken');
            }
            return job.status;
        }
    };

    ctrl.continueSubmission = function () {
        var submissionNumber = $scope.submissionNumber;
        console.info('QuoteDetailCtrl.continueSubmission submissionNumber=' + submissionNumber + ' gatewayQuote=' + $scope.gatewayQuote + ' lobCode=' + $scope.latestPeriod.policyLines[0].lineOfBusinessCode);
        if ($scope.gatewayQuote && _.contains(lobConfig.lobs, lobMap[$scope.latestPeriod.policyLines[0].lineOfBusinessCode])) {
            $state.transitionTo('quoteentry', {
                postalCode: $scope.accountInfo.primaryAddress.postalCode,
                quoteID: submissionNumber
            });
        } else {
            // Redirect to PolicyCenter EntryPoint to continue new submission
            $window.location.href = GPA_PC_ENTRY_POINT + '?JobNumber=' + submissionNumber;
        }
    };

    ctrl.withdrawSubmission = function () {
        var submissionNumber = $scope.submissionNumber;
        var message = $translate('gateway.directives.JobSummary.Are you sure you want to withdraw quote:').then(function (msg) {
            return msg + ' ' + submissionNumber + '?';
        });
        var modalPromise = ModalService.showWarning('gateway.directives.JobSummary.Withdraw Job', message, undefined, $filter('translate')('gateway.directives.JobSummary.Withdraw')).result;

        modalPromise.then(function () {
            $scope.withdrawQuotePromise = SubmissionService.withdrawSubmissionBySubmissionNumber(submissionNumber).then(function () {
                var status = InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Withdrawn');
                $scope.submission.status = status.name;
                $scope.submissionStatusString = status.name;
                $scope.submission.statusCode = status.code;
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.JobSummary.Failed to withdraw submission');
            });
        });
    };

    function updateSummaryFromServer() {
        return SubmissionService.getSubmissionSummary($stateParams.submissionNumber).then(function (submissionSummary) {
            $scope.submissionSummary = submissionSummary;
        }, function () {});
    }

    $scope.$on('notesUpdated', updateSummaryFromServer);
    $scope.$on('documentsUpdated', updateSummaryFromServer);

    $scope.$on('activitiesUpdated', function () {
        updateSummaryFromServer();
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', 'lobConfig', '$window', '$q', '$stateParams', 'SubmissionService', 'ActivityService', '$modal', 'ModalService', '$filter', 'UserService', '$translate', 'InsuranceSuiteMetadata', 'defaultLocaleDetails', 'GPA_PC_ENTRY_POINT'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/QuoteDetailCtrl.js
// module id = 1683
// module chunks = 0